import { setNameRowDetail } from "../setNameRowDetail"
import { setFieldsErrors } from "../../../../../../../utils/setFieldsErrors"
import { translateMessage } from "../../../../../../../utils/translateMessage"
import { Variables } from "../../../../constants/add/variables"
import { HandleServerFieldValidationErrorProps } from "../../../../models/add"

const { E0017, E0105, E0106, SERVER_VALIDATION_ERROR_FIELD_MAPPING } = Variables
const messages = [E0017, E0105, E0106]

// eslint-disable-next-line complexity, max-statements
export const handleServerFieldValidationError = ({
  error,
  form,
  handleError,
  handleErrorValidate,
  setDetailValidMsg,
  setLodgingValidMsg,
}: HandleServerFieldValidationErrorProps) => {
  const data = error?.debug?.response?.data
  const entityName = error?.debug?.response?.data?.entityName
  const indexes = entityName.split(",").map(Number)
  const errorFieldMapping = SERVER_VALIDATION_ERROR_FIELD_MAPPING[data?.message]

  if (errorFieldMapping) {
    const { field, message } = errorFieldMapping

    form.setFields(
      indexes.map((index) => ({
        errors: [message],
        name: `${setNameRowDetail(index)}.${field}`,
      })),
    )

    if (indexes.length > 0) {
      form.scrollToField(`${setNameRowDetail(indexes[0])}.${field}`)
    }
  } else {
    if (entityName && !["detail", "lodging"].includes(entityName))
      setFieldsErrors(error, form)
    else if (messages.includes(data?.message)) {
      if (entityName === "detail") {
        setDetailValidMsg(translateMessage(`MESSAGE.${data.message}`))
      } else if (entityName === "lodging") {
        setLodgingValidMsg(translateMessage(`MESSAGE.${data.message}`))
      } else {
        handleErrorValidate(data.message, entityName)
      }
    } else handleError(error)
  }
}
